// eslint-disable-next-line import/prefer-default-export
export const FETCH_NAVIGATION_STRUCTURE_SUCCESS = 'fetchNavigationStructureSuccess';
